import gql from 'graphql-tag'

export const GET_REPORT_MANAGEMENT_DRIVER = gql`
  query ReportManagementDriver($filter: ReportManagementDriverFilter!) {
    reportManagementDriver(filter: $filter) {
      isSuccessful
      message
      reportManagementDriver {
        data {
          totalDistance
          totalTimeTrip
          totalTimeTripStop
          totalTimeTripFormatted
          totalTimeTripStopFormatted
          driver {
            fullname
          }
        }
        pagination {
          total
          page
          show
          actualTotal
        }
      }
    }
  }
`

export const GET_REPORT_MANAGEMENT_VEHICLE = gql`
  query ReportManagementVehicle($filter: ReportManagementVehicleFilter!) {
    reportManagementVehicle(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportManagementVehicle {
        data {
          vehicle {
            licensePlate
            vehicleType {
              type
              model
              manufacturer
            }
            imei
            device {
              deviceType
            }
          }
          fuelEficiency
          totalEficiency
          totalMoving
          totalHourMoving
          totalTimeTripStop
          averageSpeed
          totalHourMovingFormatted
          totalTimeTripStopFormatted
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`
export const GET_REPORT_HISTORY_FLEET = gql`
  query ReportVehicleTrip($filter: ReportVehicleTripFilter) {
    reportVehicleTrip(filter: $filter) {
      isSuccessful
      message
      status
      reportVehicleTrips {
        data {
          efficiency
          standardFuel
          averageSpeed
          totalTimeTrip
          totalHourStop
          totalIdleTime
          reportVehicleTrip {
            vehicleId
            driver {
              fullname
            }
            vehicle {
              licensePlate
              driver1 {
                fullname
              }
              driver2 {
                fullname
              }
              vehicleType {
                manufacturer
                model
                type
                fuelEfficiency
              }
            }
            driverId
            tripMileage
            startLong
            startLat
            startAddress
            stopLong
            stopLat
            stopAddress
            maxSpeed
            startTime
            stopTime
            startGeofence
            stopGeofence
            tripFuel
            lastOdometer
          }
        }
        summary {
          totalDate
          totalTripMileage
          totalTimeTrip
          totalStandardFuel
          totalAverageSpeed
          totalHourStop
          totalIdleTime
          totalActualFuel
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`

export const GET_REPORT_DETAIL_HISTORY_FLEET = gql`
  query ReportDetailVehicleTrip($filter: ReportDetailVehicleTripFilter) {
    reportDetailVehicleTrip(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportDetailVehicleTrips {
        data {
          reportDetailVehicleTrip {
            vehicleId
            vehicle {
              licensePlate
              vehicleType {
                type
                model
                manufacturer
              }
              imei
              device {
                deviceType
              }
            }
            latitude
            longitude
            speed
            sentOn
            address
            geofence
            acc
          }
          driver {
            fullname
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`
export const GET_REPORT_SUMMARY_DAY_BY_VEHICLE = gql`
  query ReportSummaryDayVehicle($filter: ReportSummaryDayVehicleFilter!) {
    reportSummaryDayVehicle(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ReportSummaryDayVehicle {
        data {
          vehicleId
          day
          finalOdometer
          totalMoving
          totalHourMoving
          totalHourTripStop
          totalHourMovingFormatted
          totalHourTripStopFormatted
          vehicle {
            licensePlate
            vehicleType {
              type
              model
              manufacturer
            }
            imei
            device {
              deviceType
            }
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_DAY_BY_DRIVER = gql`
  query ReportSummaryDayDriver($filter: ReportSummaryDayFilter) {
    reportSummaryDayDriver(filter: $filter) {
      isSuccessful
      message
      ReportSummaryDayDriver {
        data {
          companyId
          vehicleId
          driverId
          day
          harshBrakes
          harshAccels
          totalMinutes
          totalFuel
          totalDistance
          totalHourTrip
          totalHourTripStop
          totalHourTripFormatted
          totalHourTripStopFormatted
          driver {
            fullname
          }
          vehicle {
            licensePlate
            vehicleType {
              manufacturer
              model
              type
              category
            }
          }
        }
        pagination {
          total
          page
          show
          actualTotal
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_STOPPED = gql`
  query ReportSummaryStopped($filter: ReportSummaryStoppedFilter!) {
    reportSummaryStopped(filter: $filter) {
      isSuccessful
      message
      status
      reportSummaryStopped {
        data {
          startTime
          stopTime
          vehicleId
          vehicle {
            licensePlate
            vehicleType {
              manufacturer
              model
              type
              category
            }
          }
          driverId
          driver {
            fullname
          }
          totalSeconds
          timeStopFormatted
          longitude
          latitude
          address
          acc
          geofence
        }
        summary {
          totalStopTimeAccOn
          totalStopTimeAccOff
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`

export const GET_REPORT_GEOLOCATION = gql`
  query VehicleGeofenceHist($filter: GetVehicleGeofenceHistFilter!) {
    vehicleGeofenceHist(filter: $filter) {
      isSuccessful
      message
      vehicleGeofenceHist {
        data {
          vehicleId
          vehicle {
            licensePlate
            vehicleType {
              model
              manufacturer
              type
              category
            }
          }
          geofenceId
          geofence
          transitOn
          inside
          driver {
            fullname
          }
        }
        pagination {
          total
          page
          show
          actualTotal
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_GEOLOCATION = gql`
  query SummaryVehicleGeofenceHist($filter: GetSummaryVehicleGeofenceHistFilter!) {
    summaryVehicleGeofenceHist(filter: $filter) {
      isSuccessful
      message
      summaryVehicleGeofenceHist {
        data {
          outTime
          inTime
          vehicleId
          vehicle {
            licensePlate
            vehicleType {
              manufacturer
              model
              type
              category
            }
          }
          geofenceId
          geofence
          inside
          duration
          driver {
            fullname
          }
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_REPORT_ALERT = gql`
  query ReportAlert($filter: GetReportAlertsFilter) {
    reportAlert(filter: $filter) {
      reportAlert {
        data {
          createdOn
          vehicleId
          alertCode
          driverId
          alertFlag
          alertData
          formattedAlertData
          latitude
          longitude
          alertTrigger
          threshold
          cost
          address
          geofence
          formattedAlertData
          isResolved
          isRead
          isImportant
          isFalseAlert
          vehicle {
            licensePlate
            vehicleType {
              model
              manufacturer
              type
              category
            }
            vehicle2Vgroup {
              vgroup {
                name
              }
            }
          }
          alert {
            alertCode
            descriptionEng
            descriptionIdn
          }
          driver {
            fullname
          }
          lastUserFeedback {
            createdOn
            userId
            feedback
            user {
              fullname
            }
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
      isSuccessful
      message
    }
  }
`

export const GET_REPORT_DOOR = gql`
  query ReportDoor($filter: GetReportDoorFilter!) {
    reportDoor(filter: $filter) {
      isSuccessful
      message
      reportDoor {
        doorOpenedOn
        doorClosedOn
        vehicleId
        vehicle {
          licensePlate
          vehicleType {
            model
            manufacturer
            type
            category
          }
        }
        driver {
          fullname
        }
        latitude
        longitude
        address
        doorSensor
        duration
      }
    }
  }
`

export const GET_REPORT_RAW_SENSOR = gql`
  query RawSensorInfos($filter: GetRawSensorInfoFilter!) {
    rawSensorInfos(filter: $filter) {
      isSuccessful
      message
      rawSensorInfos {
        createdOn
        vehicleId
        vehicle {
          licensePlate
          vehicleType {
            manufacturer
            model
            category
            type
          }
        }
        fuel
        temperature
        temperature2
        temperature3
        loadSensor
        speed
        address
        door1
        door2
        acc
        refrigerator
        geofence
        latitude
        longitude
      }
    }
  }
`

export const GET_REPORT_FUEL = gql`
  query ReportFuel($filter: GetReportFuelFilter!) {
    reportFuel(filter: $filter) {
      isSuccessful
      message
      reportFuel {
        data {
          address
          createdOn
          fuel
          fuelPercentage
          speed
          acc
          geofence
          vehicle {
            boxType
            carrosserie
            companyId
            id
            driver1Id
            driver2Id
            garageId
            tonnage
            volume
            fuelEfficiency
            fuelCapacity
            odometer
            status
            imei
            licensePlate
            vehicleType {
              vehicleTypeId
              companyId
              isActive
              manufacturer
              model
              transmissionType
              tonnage
              type
              volume
              hasRelation
              fuelType {
                fuelTypeId
                name
                category
              }
              category
            }
            vehicleTypeId
            thermoType
            year
            machineNumber
            vehicleDocs {
              licensePlate
              status
              validUntil
              vehicleId
              docType
              docNumber
            }
            garage {
              address
              category
              addressDetail
              fenceName
              geofenceId
              companyId
            }
            chassisNumber
            company {
              id
            }
          }
          averageFuelConsumption
        }
        summary {
          totalFuelConsumption
          averageFuelConsumption
          countFuelRefill
          totalFuelRefill
          countAnomalyFuelLoss
          totalAnomalyFuelLoss
          averageSpeed
        }
      }
    }
  }
`

export const GET_REPORT_DRIVER_SCORES = gql`
  query DriverScores($filter: GetDriverScoresFilter) {
    driverScores(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      driverScores {
        data {
          companyId
          driverId
          driver {
            userId
            fullname
          }
          year
          month
          score
          finalGrade
          totalDriven
          totalHours
          totalAlert
          harshAccel {
            total
            score
          }
          harshBrake {
            total
            score
          }
          sharpturn {
            total
            score
          }
          overspeed {
            total
            score
          }
          exceededParkingTime {
            total
            score
          }
          exceededIdleTime {
            total
            score
          }
          yawn {
            total
            score
          }
          distraction {
            total
            score
          }
          smoking {
            total
            score
          }
          phoneCalling {
            total
            score
          }
          eyeClosed {
            total
            score
          }
          missingFace {
            total
            score
          }
        }
        aggregation {
          averageScore
          averageFinalGrade
          totalDriver
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_FUEL = gql`
  query SummaryFuel($filter: GetSummaryFuelFilter!) {
    summaryFuel(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryFuel {
        data {
          licensePlate
          vehicleType {
            vehicleTypeId
            companyId
            isActive
            manufacturer
            model
            type
            category
            transmissionType
            fuelType {
              fuelTypeId
              name
              category
            }
            tonnage
            volume
            fuelEfficiency
            hasRelation
          }
          countRefueling
          countFuelLoss
          totalFuel
          totalDistance
          totalHours
          idleDuration
          actualEfficiency
          actualTotalFuel
          actualPrice
          fuelEfficiencyDifference
          fuelDifference
          fuelDifferencePrice
          standardFuel
          standardPrice
          price
        }
        summary {
          sumCountRefueling
          sumCountFuelLoss
          sumActualEfficiency
          sumActualTotalFuel
          sumActualPrice
          sumFuelDifference
          sumFuelDifferencePrice
          sumStandardFuel
          sumTotalFuel
          sumTotalDistance
          sumTotalHours
          sumIdleDuration
          sumStandardPrice
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_FUEL_PAGINATION = gql`
  query SummaryFuel($filter: GetSummaryFuelFilter!) {
    summaryFuel(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryFuel {
        data {
          licensePlate
          vehicleType {
            vehicleTypeId
            companyId
            isActive
            manufacturer
            model
            type
            category
            transmissionType
            fuelType {
              fuelTypeId
              name
              category
            }
            tonnage
            volume
            fuelEfficiency
            hasRelation
          }
          countRefueling
          countFuelLoss
          totalFuel
          totalDistance
          totalHours
          idleDuration
          actualEfficiency
          actualTotalFuel
          actualPrice
          fuelEfficiencyDifference
          fuelDifference
          fuelDifferencePrice
          standardFuel
          standardPrice
          price
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`

export const DELETE_DOWNLOAD_HISTORY = gql`
  mutation DeleteDownloadHistory($input: UpdateDownloadHistoriesFilter!) {
    deleteDownloadHistory(input: $input) {
      isSuccessful
      message
    }
  }
`

export const RELOAD_DOWNLOAD_HISTORY = gql`
  mutation RedownloadDownloadHistory($filter: RedownloadDownloadHistoriesFilter) {
    redownloadDownloadHistory(filter: $filter) {
      isSuccessful
      message
      redownloadDownloadHistory {
        base64
        id
      }
    }
  }
`

export const GET_REPORT_TIME_WINDOW = gql`
  query ReportTimeWindow($filter: GetReportTimeWindowFilter!) {
    reportTimeWindow(filter: $filter) {
      isSuccessful
      message
      reportTimeWindow {
        data {
          data {
            doorClose
            doorOpen
            geofence {
              address
              addressDetail
              circData
              category
              city
              companyId
              contactName
              fenceName
              geofenceId
              hasRelation
              isGarage
              isServiceLoc
              phoneNo
              polyData
              postalCode
              province
              serviceLocType
              type
            }
            geofenceId
            timeBetweenGeofence
            timeInGeofence
            timeInQueue
            timeLoading
            timeOutQueue
            transitOn
            transitOnOut
            vehicleId
          }
          in
          out
          time
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_DOWNLOAD_HISTORIES = gql`
  query DownloadHistory($filter: DownloadHistoriesFilter) {
    downloadHistory(filter: $filter) {
      isSuccessful
      message
      downloadHistory {
        companyId
        downloadHistoryId
        userId
        title
        startDate
        endDate
        downloadOn
        typeCode
        filter
        url
        status
      }
    }
  }
`

export const GET_SUMMARY_ENGINE_PTO = gql`
  query SummaryEnginePTO($filter: SummaryEnginePTOFilter!) {
    summaryEnginePTO(filter: $filter) {
      isSuccessful
      message
      summaryEnginePTO {
        pagination {
          page
          show
          total
        }
        summary {
          engineOnDuration
          ptoDuration
        }
        data {
          date
          day
          driver {
            fullname
          }
          engineOnDuration
          ptoDuration
          vehicle {
            id
            licensePlate
            hullNo
            vehicleType {
              manufacturer
              model
              type
              category
            }
          }
        }
      }
    }
  }
`

export const GET_SUMMARY_ENGINE = gql`
  query SummaryEngine($filter: SummaryEngineFilter!) {
    summaryEngine(filter: $filter) {
      isSuccessful
      message
      summaryEngine {
        data {
          driver {
            fullname
          }
          ptoDuration
          engineOnDuration
          startLocation {
            lat
            lon
          }
          startTime
          stopLocation {
            lat
            lon
          }
          stopTime
          vehicle {
            id
            licensePlate
            hullNo
            vehicleType {
              manufacturer
              model
              type
              category
            }
          }
        }
        pagination {
          page
          show
          total
        }
        summary {
          engineOnDuration
          ptoDuration
        }
      }
    }
  }
`

export const GET_REPORT_SCHEDULERS = gql`
  query ReportSchedulers($filter: GetReportSchedulerFilter) {
    reportSchedulers(filter: $filter) {
      isSuccessful
      message
      reportSchedulers {
        data {
          aggregate {
            whatsapp
            email
          }
          reportSchedulerId
          companyId
          userId
          scheduleName
          reportName
          reportKey
          period
          periodLabel
          noOfDay
          time
          startTime
          recipients
          filter
          canDelete
          vgroup {
            id
            name
            totalVehicle
            vehicleList {
              id
              licensePlate
            }
          }
          isSavedReport
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_DETAIL_REPORT_SCHEDULER = gql`
  query ReportScheduler($filter: GetAReportSchedulerFilter!) {
    reportScheduler(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportScheduler {
        reportSchedulerId
        companyId
        userId
        scheduleName
        reportName
        reportKey
        period
        periodLabel
        noOfDay
        time
        recipients
        filter
        canDelete
        vgroup {
          id
          name
          totalVehicle
          vehicleList {
            id
            licensePlate
          }
        }
        title
        body
        startTime
        endTime
        isActive
        reportSchedulerContent {
          reportSchedulerId
          contentId
          contentType
        }
        contactRecipients {
          contactId
          companyId
          userId
          label
          phoneNumber
          email
        }
        isSavedReport
      }
    }
  }
`

export const GET_OVERSPEED_DURATIONS = gql`
  query OverspeedDurations($filter: OverspeedDurationFilter) {
    overspeedDurations(filter: $filter) {
      isSuccessful
      overspeedDurations {
        data {
          overspeedDatas {
            vehicleId
            startLatitude
            startLongitude
            endLatitude
            endLongitude
            startDate
            endDate
            duration
            distance
            maxSpeed
            speedLimit
            driver {
              fullname
            }
            vehicle {
              hullNo
              licensePlate
              vehicleType {
                manufacturer
                model
                type
                category
              }
            }
          }
          totalDuration
        }
        pagination {
          total
          page
          show
        }
      }
      message
    }
  }
`

export const GET_REPORT_SCHEDULER_HISTORY = gql`
  query ReportSchedulerHistory($filter: GetReportSchedulerHistoryFilter) {
    reportSchedulerHistory(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportSchedulerHistory {
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
        data {
          sentOn
          companyId
          userId
          scheduleName
          reportName
          recipients
          status
          reportSchedulerId
          type
        }
      }
    }
  }
`

export const GET_SUMMARY_ALERT = gql`
  query SummaryAlert($filter: SummaryAlertFilter!) {
    summaryAlert(filter: $filter) {
      isSuccessful
      message
      summaryAlert {
        data {
          driver {
            fullname
          }
          totalDistance
          vehicle {
            licensePlate
          }
          alerts {
            totalAlert
            alertFlag
            alertCode
            alertName
          }
        }
        pagination {
          total
          page
          show
        }
        summary {
          totalDistance
          totalAlert {
            alertName
            totalAlert
          }
        }
      }
    }
  }
`

export const EXPORT_REPORT_SUMMARY_ENGINE_PTO = gql`
  query SummaryEnginePTOReport($filter: GetSummaryEnginePTOReportFilter!) {
    summaryEnginePTOReport(filter: $filter) {
      isSuccessful
      message
      summaryEnginePTOReport {
        base64
        id
      }
    }
  }
`

export const CREATE_REPORT_SCHEDULER = gql`
  mutation CreateReportScheduler($input: CreateReportSchedulerInput!) {
    createReportScheduler(input: $input) {
      isSuccessful
      message
      reportScheduler {
        reportSchedulerId
      }
    }
  }
`

export const UPDATE_REPORT_SCHEDULER = gql`
  mutation UpdateReportScheduler($input: UpdateReportSchedulerInput!) {
    updateReportScheduler(input: $input) {
      isSuccessful
      message
      updateReportScheduler {
        reportSchedulerId
      }
    }
  }
`

export const EXPORT_REPORT_SUMMARY_ENGINE = gql`
  query SummaryEngineReport($filter: GetSummaryEngineReportFilter!) {
    summaryEngineReport(filter: $filter) {
      isSuccessful
      message
      summaryEngineReport {
        base64
        id
      }
    }
  }
`

export const DELETE_REPORT_SCHEDULER = gql`
  mutation DeleteReportScheduler($input: DeleteReportSchedulerInput) {
    deleteReportScheduler(input: $input) {
      isSuccessful
      message
      reportScheduler {
        reportSchedulerId
      }
    }
  }
`

export const EXPORT_REPORT_OVERSPEED_DURATIONS = gql`
  query OverspeedDurationsReport($filter: GetOverspeedDurationsFilter!) {
    overspeedDurationsReport(filter: $filter) {
      isSuccessful
      message
      overspeedDurationsReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_SUMMARY_ALERT = gql`
  query ReportSummaryAlert($filter: GetSummaryAlertFilter!) {
    reportSummaryAlert(filter: $filter) {
      isSuccessful
      message
      status
      summaryAlertReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_SERVICE_SCHEDULE = gql`
  query ServiceSchedulesReport($filter: GetServiceSchedulesReportFilter!) {
    serviceSchedulesReport(filter: $filter) {
      isSuccessful
      message
      serviceSchedulesReport {
        base64
        id
      }
      status
    }
  }
`

export const EXPORT_REPORT_SUMMARY_FUEL = gql`
  query SummaryFuelReport($filter: GetSummaryFuelReportFilter!) {
    summaryFuelReport(filter: $filter) {
      isSuccessful
      message
      summaryFuelReport {
        base64
        id
      }
      status
    }
  }
`

export const GET_OFFLINE_VEHICLE_REPORT = gql`
  query ReportVehiclesOffline($filter: VehicleOfflineFilter) {
    reportVehiclesOffline(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportVehiclesOffline {
        data {
          vehicleId
          vehicle {
            licensePlate
            vehicleType {
              type
              model
              manufacturer
            }
            imei
            device {
              deviceType
            }
          }
          driver {
            fullname
          }
          vgroups
          offlineDate
          totalOfflineTime
          totalOfflineTimeSeconds
          lastLocation
          latitude
          longitude
          geofence
          lastAlert {
            createdOn
            alertCode
            descriptionIdn
            descriptionEng
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_FUEL_DAILY = gql`
  query SummaryFuelDaily($filter: GetSummaryFuelDailyFilter!) {
    summaryFuelDaily(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryFuelDaily {
        data {
          date
          licensePlate
          fuelStart {
            percentage
            volume
          }
          fuelEnd {
            percentage
            volume
          }
          refueling {
            count
            volume
          }
          fuelLoss {
            count
            volume
          }
          totalFuel
          totalDistance
          totalHours
          idleDuration
          actualEfficiency
          standardEfficiency
          statusEfficiency
        }
        summary {
          totalFuel
          totalDistance
          totalHours
          idleDuration
          fuelLoss {
            count
            volume
          }
          refueling {
            count
            volume
          }
        }
        pagination {
          total
          page
          show
          actualTotal
        }
      }
    }
  }
`

export const EXPORT_REPORT_SUMMARY_FUEL_DAILY = gql`
  query SummaryFuelDailyReport($filter: SummaryFuelDailyReportFilter) {
    summaryFuelDailyReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryFuelDailyReport {
        base64
        id
      }
    }
  }
`

export const GET_REPORT_FUEL_PAGINATED = gql`
  query ReportFuelPaginated($filter: GetReportFuelFilter) {
    reportFuelPaginated(filter: $filter) {
      isSuccessful
      message
      reportFuelPaginated {
        data {
          address
          createdOn
          fuel
          fuelPercentage
          speed
          acc
          geofence
          latitude
          longitude
          vehicle {
            boxType
            carrosserie
            companyId
            id
            driver1Id
            driver2Id
            garageId
            tonnage
            volume
            fuelEfficiency
            fuelCapacity
            odometer
            status
            imei
            licensePlate
            vehicleType {
              vehicleTypeId
              companyId
              isActive
              manufacturer
              model
              transmissionType
              tonnage
              type
              volume
              hasRelation
              fuelType {
                fuelTypeId
                name
                category
              }
              category
            }
            vehicleTypeId
            thermoType
            year
            machineNumber
            vehicleDocs {
              licensePlate
              status
              validUntil
              vehicleId
              docType
              docNumber
            }
            garage {
              address
              category
              addressDetail
              fenceName
              geofenceId
              companyId
            }
            chassisNumber
            company {
              id
            }
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`

export const GET_REPORT_RAW_SENSOR_PAGINATED = gql`
  query RawSensorInfoPaginated($filter: GetRawSensorInfoFilter!) {
    rawSensorInfoPaginated(filter: $filter) {
      isSuccessful
      message
      rawSensorInfoPaginated {
        data {
          createdOn
          vehicleId
          vehicle {
            licensePlate
            vehicleType {
              manufacturer
              model
              category
              type
            }
          }
          fuel
          temperature
          temperature2
          temperature3
          loadSensor
          speed
          address
          door1
          door2
          acc
          refrigerator
          geofence
          latitude
          longitude
        }
        pagination {
          page
          show
          total
          actualTotal
        }
      }
    }
  }
`
export const RAW_SENSOR_INFO_REPORT = gql`
  query RawSensorInfoReport($filter: RawSensorInfoReportInput) {
    rawSensorInfoReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rawSensorInfoReport {
        base64
        id
      }
    }
  }
`
export const GET_REPORT_HISTORY_CONNECTIVITY_GPS = gql`
  query RawSensorHour($filter: GetRawSensorHourFilterType!) {
    rawSensorHour(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rawSensorHour {
        data {
          createdOn
          vehicleId
          vehicle {
            licensePlate
            vehicleType {
              type
              model
              manufacturer
            }
            imei
            device {
              deviceType
            }
          }
          latitude
          longitude
          gsmSignal
          address
          signalStrength
          batteryVoltage
          batteryPerc
          geofence
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
export const FUEL_REPORT = gql`
  query FuelReport($filter: FuelReportInput) {
    fuelReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelReport {
        base64
        id
      }
    }
  }
`
export const EXPORT_REPORT_HISTORY_CONNECTIVITY_GPS = gql`
  query RawSensorHourReport($filter: RawSensorHourReportFilter) {
    rawSensorHourReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      rawSensorHourReport {
        base64
        id
      }
    }
  }
`
export const EXPORT_REPORT_DOOR_PAGINATED = gql`
  query ReportDoorPaginated($filter: GetReportDoorFilter!) {
    reportDoorPaginated(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportDoorPaginated {
        data {
          doorOpenedOn
          doorClosedOn
          vehicleId
          vehicle {
            licensePlate
            vehicleType {
              model
              manufacturer
              type
              category
            }
          }
          driver {
            fullname
          }
          latitude
          longitude
          address
          doorSensor
          duration
          geofence
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`
export const EXPORT_DOOR_REPORT = gql`
  query DoorReport($filter: DoorReportInput) {
    doorReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      doorReport {
        base64
        id
      }
    }
  }
`
export const GET_REPORT_HISTORICAL_OFFLINE_GPS = gql`
  query HistoricalOfflineGps($filter: HistoricalOfflineGpsFilter!) {
    historicalOfflineGps(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      historicalOfflineGps {
        data {
          vehicle {
            licensePlate
            vehicleType {
              type
              model
              manufacturer
            }
            imei
            device {
              deviceType
            }
          }
          startTime
          startLocation
          startLatitude
          startLongitude
          startActivity
          stopTime
          stopLocation
          stopLatitude
          stopLongitude
          stopActivity
          offlineDuration
          driver {
            fullname
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const EXPORT_REPORT_HISTORICAL_OFFLINE_GPS = gql`
  query HistoricalOfflineGpsReport($filter: ReportHistoricalOfflineGpsFilter) {
    historicalOfflineGpsReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      historicalOfflineGpsReport {
        base64
        id
      }
    }
  }
`

export const GET_FAVORITE_REPORTS = gql`
  query FavoriteReports($filter: GetReportFavoritesInput!) {
    favoriteReports(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      favoriteReports {
        userId
        favoriteReportKeys
        type
      }
    }
  }
`

export const UPDATE_FAVORITE_REPORTS = gql`
  mutation UpdateReportFavorites($input: UpdateReportFavoritesInput!) {
    updateReportFavorites(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      UpdateReportFavorites {
        reportKey
        message
        status
      }
    }
  }
`

export const GET_TRIPS_BETWEEN_GEOFENCES = gql`
  query TripsBetweenGeofences($filter: TripsBetweenGeofencesFilter!) {
    tripsBetweenGeofences(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      tripsBetweenGeofences {
        data {
          vehicle {
            id
            licensePlate
            odometer
          }
          driver {
            fullname
          }
          moveDuration
          idleDuration
          intersectGeofences {
            geofenceId
            fenceName
          }
          speed
          tripFuel
          stopDuration
          tripDuration
          fuelEfficiency
          startTime
          stopTime
          vehicleId
          driverId
          tripMileage
          startLong
          startLat
          stopLong
          stopLat
          maxSpeed
          type
          totalHourStart
          totalHourStop
          anomaly {
            summary
            mileage
            tripFuel
            tripDuration
            moveDuration
            idleDuration
            stopDuration
            speed
            fuelEfficiency
          }
        }
        aggregate {
          anomaly {
            mileage
            tripFuel
            tripDuration
            moveDuration
            idleDuration
            stopDuration
            speed
            fuelEfficiency
          }
          total {
            mileage
            tripFuel
            tripDuration
            moveDuration
            idleDuration
            stopDuration
            speed
            fuelEfficiency
          }
          avg {
            mileage
            tripFuel
            tripDuration
            moveDuration
            idleDuration
            stopDuration
            speed
            fuelEfficiency
          }
        }
        info {
          startGeofence {
            geofenceId
            fenceName
          }
          endGeofence {
            geofenceId
            fenceName
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_REPORT_SUMMARY_WORKING_HOURS = gql`
  query SummaryWorkingHours($filter: SummaryWorkFilter) {
    summaryWorkingHours(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryWork {
        data {
          date
          day
          vehicle {
            licensePlate
            imei
            vehicleType {
              model
              manufacturer
              type
            }
          }
          drivers
          totalWorkingHours
          lastEngineOn
        }
        pagination {
          total
          show
          page
        }
      }
    }
  }
`

export const EXPORT_REPORT_SUMMARY_WORKING_HOURS = gql`
  query SummaryWorkingHoursReport($filter: SummaryWorkReportFilter) {
    summaryWorkingHoursReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryWorkReport {
        base64
        id
      }
    }
  }
`

export const SUMMARY_GEOLOCATION_REPORT = gql`
  query SummaryGeolocationReport($filter: GetSummaryGeolocationReportFilter) {
    summaryGeolocationReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryGeolocationReport {
        base64
        id
      }
    }
  }
`

export const GEOLOCATION_REPORT = gql`
  query GeolocationReport($filter: GeolocationReportFilter!) {
    geolocationReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      geolocationReport {
        base64
        id
      }
    }
  }
`

export const SUMARY_ENGINE_REPORT = gql`
  query SummaryEngineReportBackground($filter: GetSummaryEngineReportBackgroundFilter!) {
    summaryEngineReportBackground(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryEngineReportBackground {
        base64
        id
      }
    }
  }
`

export const DRIVER_SCORE_REPORT = gql`
  query DriverScoresReport($filter: DriverScoresReportFilter!) {
    driverScoresReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      driverScoresReport {
        filename
        base64
        id
      }
    }
  }
`

export const SUMMARY_STOPPED_REPORT = gql`
  query SummaryStoppedReport($filter: SummaryStoppedReportFilter) {
    summaryStoppedReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryStoppedReport {
        base64
        id
      }
    }
  }
`

export const OVERSPEED_DURATION_REPORT = gql`
  query OverspeedDurationReport($filter: GetOverspeedDurationsReportFilter) {
    overspeedDurationReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      overspeedDurationReport {
        base64
        id
      }
    }
  }
`

export const TIME_WINDOW_REPORT = gql`
  query TimeWindowReport($filter: GetTimeWindowReportFilter) {
    timeWindowReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      timeWindowReport {
        base64
        id
      }
    }
  }
`

export const UPDATE_DOWNLOAD_HISTORY = gql`
  mutation UpdateDownloadHistoryV2($input: UpdateDownloadHistoriesFilterV2!) {
    updateDownloadHistoryV2(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateDownloadHistoryV2 {
        downloadHistoryAmount
        downloadHistoryChildrenAmount
      }
    }
  }
`

export const VEHICLE_STATUS_REPORT = gql`
  query LastLocationVehicle($filter: ReportVehicleLastLocationFilter) {
    lastLocationVehicle(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      lastLocationVehicle {
        data {
          lastPositionStatus
          vehicleId
          licensePlate
          latitude
          longitude
          speed
          temperature
          temperature2
          temperature3
          acc
          motionStatus
          geofence
          fuel
          door1
          door2
          refrigerator
          lastReceive
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const EXPORT_VEHICLE_STATUS_REPORT = gql`
  query LastLocationVehicleReport($filter: VehicleLastPositionReportFilter!) {
    lastLocationVehicleReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      lastLocationVehicleReport {
        base64
        id
      }
    }
  }
`

export const GET_REPORT_GEOLOCATION_DURATION = gql`
  query DurationInGeolocation($filter: DurationInGeolocationFilter!) {
    durationInGeolocation(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      durationInGeolocation {
        data {
          licensePlate
          driverName
          fenceName
          geolocationIn
          geolocationOut
          totalDurationFormatted
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const EXPORT_REPORT_GEOLOCATION_DURATION = gql`
  query DurationInGeolocationReport($filter: DurationInGeolocationReportFilter) {
    durationInGeolocationReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      durationInGeolocationReport {
        filename
        content
        encoding
        base64
        id
      }
    }
  }
`

export const GET_SAVED_REPORT = gql`
  query SavedReports {
    savedReports {
      isSuccessful
      errorCode
      errorName
      message
      status
      savedReports {
        savedReportsId
        userId
        reportKey
        reportName
        filter
        dateType
        description
      }
    }
  }
`

export const GET_REPORT_HISTORY_ROUTE = gql`
  query RouteRitageHistory($filter: RouteRitageHistoryInput!) {
    routeRitageHistory(filter: $filter) {
      isSuccessful
      errorCode
      message
      status
      getRouteRitageHistory {
        data {
          vehicleId
          licensePlate
          ritageId
          ritageName
          departure {
            routeId
            routeName
            startOn
            endOn
            distanceDriven
            geofenceIds
            geofenceNames
            routeRecordId
          }
          return {
            routeId
            routeName
            startOn
            endOn
            distanceDriven
            geofenceIds
            geofenceNames
            routeRecordId
          }
          totalDistanceDriven
          seq
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const CREATE_SAVED_REPORT = gql`
  mutation CreateSavedReport($input: CreateSavedReportInput!) {
    createSavedReport(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createSavedReport {
        savedReportsId
        userId
        reportKey
        reportName
        filter
      }
    }
  }
`

export const GET_REPORT_SUMMARY_RITAGE_ROUTE = gql`
  query SummaryRitageReport($filter: GetReportSummaryRitageFilter) {
    summaryRitageReport(filter: $filter) {
      reportSummaryRitage {
        data {
          licensePlate
          ritageName
          startDate
          departure {
            routeId
            routeName
            geofenceIds
            geofenceNames
          }
          return {
            routeId
            routeName
            geofenceIds
            geofenceNames
          }
          ritageCount
          totalDistanceDriven
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const UPDATE_SAVED_REPORT = gql`
  mutation UpdateSavedReport($input: UpdateSavedReportInput!) {
    updateSavedReport(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateSavedReport {
        savedReportsId
        userId
        reportKey
        reportName
        filter
      }
    }
  }
`
export const EXPORT_REPORT_HISTORY_ROUTE = gql`
  query RouteRitageHistoryReportBackground(
    $filter: GetRouteRitageHistoryReportBackgroundFilterType!
  ) {
    routeRitageHistoryReportBackground(filter: $filter) {
      errorCode
      message
      status
      getRouteRitageHistoryReportBackground {
        filename
        id
      }
      isSuccessful
    }
  }
`

export const DELETE_SAVED_REPORT = gql`
  mutation DeleteSavedReport($input: DeleteSavedReportInput!) {
    deleteSavedReport(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      deleteSavedReport {
        savedReportsId
        userId
        reportKey
        reportName
        filter
      }
    }
  }
`
export const EXPORT_REPORT_SUMMARY_RITAGE_ROUTE = gql`
  query SummaryRitageReportBackground($filter: ExportReportSummaryRitageFilter) {
    summaryRitageReportBackground(filter: $filter) {
      errorCode
      errorName
      isSuccessful
      message
      exportReportSummaryRitage {
        base64
        filename
        id
        content
        encoding
      }
      status
    }
  }
`

export const EXPORT_TRIPS_BETWEEN_GEOFENCES_REPORT = gql`
  query TripsBetweenGeofencesReport($filter: GetTripsBetweenGeofencesFilter!) {
    tripsBetweenGeofencesReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      tripsBetweenGeofencesReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_DETAIL_VEHICLE_TRIP = gql`
  query DetailVehicleTripReport($filter: DetailVehicleTripReportFilter!) {
    detailVehicleTripReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      detailVehicleTripsReport {
        filename
        content
        encoding
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_SUMMARY_DAY_BY_VEHICLE = gql`
  query SummaryDayVehicleReport($filter: SummaryDayVehicleReportFilter!) {
    summaryDayVehicleReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryDayVehicleReport {
        base64
        id
      }
    }
  }
`

export const GET_REPORT_FLEET_UTILIZATION_IJP = gql`
  query ReportFleetUtilizationIjp($filter: GetReportFleetUtilizationIjpWindowFilter!) {
    reportFleetUtilizationIjp(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      reportFleetUtilizationIjp {
        data {
          geofence
          licensePlate
          tripDuration
          ritageDuration
          tripMileage
          ritageMileage
          ritageMileageZone {
            zone1
            zone2
            zone3
            zone4
            zone5
            zone6
            total
          }
          fuelAdded
          fuelRatioPerKm
          fuelRatioPerHour
          ritageDurationZone {
            zone1
            zone2
            zone3
            zone4
            zone5
            zone6
            zone7
            total
          }
          safety {
            overspeed
            maximumOverspeed
            harshBraking
            harshAccels
            harshCornering
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const EXPORT_REPORT_FLEET_UTILIZATION_IJP = gql`
  query ReportFleetUtilizationIjpBackground($filter: ExportReportFleetUtilizationIjpFilter) {
    reportFleetUtilizationIjpBackground(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      exportReportFleetUtilizationIjp {
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_VEHICLE_TRIP = gql`
  query VehicleTripReport($filter: VehicleTripReportFilter) {
    vehicleTripReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vehicleTripReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_MANAGEMENT_VEHICLE = gql`
  query ManagementVehicleReport($filter: ManagementVehicleReportFilter!) {
    managementVehicleReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      managementVehicleReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_SUMMARY_DAY_BAY_DRIVER = gql`
  query SummaryDayDriverReport($filter: SummaryDayFilterReport) {
    summaryDayDriverReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      summaryDayDriverReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_MANAGEMENT_DRIVER = gql`
  query ManagementDriverReport($filter: ManagementDriverReportFilter) {
    managementDriverReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      managementDriverReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_REPORT_ALERT = gql`
  query AlertReport($filter: AlertReportFilter!) {
    alertReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      alertReport {
        base64
        id
      }
    }
  }
`

export const EXPORT_GET_CONTACTS_REPORT = gql`
  query ContactWithUsers($filter: GetContactWithUsersFilter) {
    contactWithUsers(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      contactWithUsers {
        data {
          contactId
          companyId
          userId
          label
          phoneNumber
          email
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
          actualTotal
        }
      }
    }
  }
`

export const GET_FUEL_RECAPITULATION_REPORT = gql`
  query FuelRecapitulation($filter: GetFuelRecapitulationFilter!) {
    fuelRecapitulation(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelRecapitulation {
        data {
          vehicle {
            id
            licensePlate
            vehicleType {
              manufacturer
              model
              type
              category
            }
          }
          standardEfficiency
          consistency
          weeklyData {
            startDate
            endDate
            totalMileage
            actualEfficiency
            fuelConsumption
          }
          totalMileage
          actualEfficiency
          fuelConsumption
        }
        pagination {
          total
          page
          show
          actualTotal
        }
        weeklyDates {
          startDate
          endDate
        }
      }
    }
  }
`
export const EXPORT_FUEL_RECAPITULATION_REPORT = gql`
  query FuelRecapitulationReport($filter: GetFuelRecapitulationReportFilter!) {
    fuelRecapitulationReport(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      fuelRecapitulationReport {
        base64
        id
      }
    }
  }
`
